import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import FormField from '../form-field';
import Alert from '../../components/alert';
import FacebookButton from '../../containers/facebook-button.container';
import Title from '../title';
import PBGUserAgreement from '../pbg-user-agreement';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  fullNameNotPresent: {
    id: 'signupForm.errors.fullName',
    defaultMessage: 'Enter your full name',
  },
  emailNotPresent: {
    id: 'signupForm.errors.email',
    defaultMessage: 'Enter an email',
  },
  passwordNotPresent: {
    id: 'signupForm.errors.passwordNotPresent',
    defaultMessage: 'Enter a password',
  },
  passwordBadLength: {
    id: 'signupForm.errors.passwordBadLength',
    defaultMessage: 'Password must be at least 8 characters',
  },
  passwordFieldLabel: {
    id: 'signupForm.fields.password.label',
    defaultMessage: 'Create password',
  },
  passwordFieldSubtext: {
    id: 'signupForm.fields.password.subtext',
    defaultMessage: 'Password must be at least 8 characters long'
  },
  emailFieldLabel: {
    id: 'signupForm.fields.email.label',
    defaultMessage: 'Email',
  },
  fullNameFieldLabel: {
    id: 'signupForm.fields.fullName.label',
    defaultMessage: 'Full name',
  },
});

class SignupForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailInUse: false,
      redirectTo: false,
    };

    this.formatMessage = formatMessage(this.props.intl);
    this.onLoginClick = this.onLoginClick.bind(this);
    this.onEmailChanged = this.onEmailChanged.bind(this);
    this.onFacebookConnect = this.onFacebookConnect.bind(this);
  }

  onEmailChanged({ target }) {
    this.props.onEmailChanged(target.value);
  }

  onFacebookConnect() {
    this.props.onFacebookConnect();
  }

  onSubmit(props) {
    this.props.onSubmit(props);
  }

  onLoginClick() {
    this.props.onLoginClick();
  }

  emailSubtext() {
    if (this.props.emailInUse) {
      return (
        <div className="small-print">
          <span className="coral-error">
            <FormattedMessage
              id="signupForm.fields.email.inUseMessage"
              defaultMessage="Email already in use"
            />
          </span>
          {' '}
          <a href="#login" onClick={this.onLoginClick}>
            <FormattedMessage
              id="signupForm.signinLink"
              defaultMessage="Sign in"
            />
          </a>
        </div>
      );
    }
    return '';
  }

  renderAlert() {
    if (!this.props.error) return null;
    return (
      <Alert type="warning" className="alert-form-top">
        <i className="fa fa-fw fa-ban" />
        {this.props.error}
      </Alert>
    );
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <div>
        {this.renderAlert()}
        <div className="modal-title text-center">
          <h1>
            <FormattedMessage
              id="signupForm.pageTitle.title"
              defaultMessage="Create account"
            />
          </h1>
          <p className="text-muted">
            <FormattedMessage
              id="signupForm.pageTitle.subtext"
              defaultMessage="It's free, quick, safe, and spam-free"
            /><br />
            <FormattedMessage
              id="signupForm.pageTitle.haveAnAccount"
              defaultMessage="Already have an account?"
            />
            {' '}
            <a href="/login" onClick={this.onLoginClick}>
              <FormattedMessage
                id="signupForm.pageTitle.signinLink"
                defaultMessage="Sign in"
              />
            </a>
          </p>
        </div>

        <Title
          text={
            <FormattedMessage
              id="signupForm.connectWithFacebook.title"
              defaultMessage="Create your account in 1 click"
            />
          }
          divider
        />

        <div className="my-3">
          <FacebookButton onConnect={this.onFacebookConnect}>
            <FormattedMessage
              id="signupForm.connectWithFacebook.button"
              defaultMessage="Connect with Facebook"
            />
          </FacebookButton>
          <span className="small-print">
            <FormattedMessage
              id="signupForm.connectWithFacebook.disclaimer"
              defaultMessage="We will never post on your behalf"
            />
          </span>
        </div>

        <Title text="Or" divider="true" />
        <form onSubmit={handleSubmit(props => this.onSubmit(props))}>
          <Field
            name="fullName"
            type="text"
            component={FormField}
            label={this.formatMessage(i18n.fullNameFieldLabel)}
          />
          <Field
            name="email"
            type="email"
            component={FormField}
            onChange={this.onEmailChanged}
            subtext={this.emailSubtext()}
            label={this.formatMessage(i18n.emailFieldLabel)}
          />
          <Field
            name="password"
            type="password"
            component={FormField}
            label={this.formatMessage(i18n.passwordFieldLabel)}
            subtext={this.formatMessage(i18n.passwordFieldSubtext)}
            disabled={this.props.emailInUse}
          />

          <button type="submit" className="btn btn-primary full-width">
            <FormattedMessage
              id="signupForm.submit.text"
              defaultMessage="Create Account"
            />
          </button>
          <p className="text-center small-print mt-2 w-75 mx-auto">
            <FormattedMessage
              id="signupForm.termsAndConditions.acceptanceText"
              defaultMessage="By signing up, you confirm that you accept the"
            />
            <br />
            <PBGUserAgreement />
          </p>
        </form>
      </div>
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  const { intl: { formatMessage } } = props;

  if (!values.fullName) {
    errors.fullName = formatMessage(i18n.fullNameNotPresent);
  }

  if (!values.email) {
    errors.email = formatMessage(i18n.emailNotPresent);
  }

  if (!values.password) {
    errors.password = formatMessage(i18n.passwordNotPresent);
  } else if (values.password.length < 8) {
    errors.password = formatMessage(i18n.passwordBadLength);
  }

  return errors;
};

SignupForm.defaultProps = {
  onEmailChanged: () => { },
  onFacebookConnect: () => { },
  onSubmit: () => { },
  onLoginClick: () => { },
};

export default injectIntl(reduxForm({ form: 'signupForm', validate })(SignupForm));



// WEBPACK FOOTER //
// ./src/desktop/components/signup/form.js